"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonColonyStandardProject = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const StandardProjectCard_1 = require("../StandardProjectCard");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const PlaceMoonColonyTile_1 = require("../../moon/PlaceMoonColonyTile");
const Units_1 = require("../../Units");
const Resources_1 = require("../../Resources");
const TileType_1 = require("../../TileType");
const CardRenderItem_1 = require("../render/CardRenderItem");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Card_1 = require("../Card");
const StandardProjectType_1 = require("../../StandardProjectType");
class MoonColonyStandardProject extends StandardProjectCard_1.StandardProjectCard {
    constructor(properties = {
        name: CardName_1.CardName.MOON_COLONY_STANDARD_PROJECT,
        cost: 22,
        tr: { moonColony: 1 },
        reserveUnits: Units_1.Units.of({ titanium: 1 }),
        metadata: {
            cardNumber: '',
            renderData: CardRenderer_1.CardRenderer.builder((b) => b.standardProject('Spend 22 M€ and 1 titanium to place a colony on the moon and raise your M€ production 1 step.', (eb) => {
                eb.megacredits(22).titanium(1).startAction.moonColony().secondaryTag(CardRenderItem_1.AltSecondaryTag.MOON_COLONY_RATE).production((pb) => pb.megacredits(1));
            })),
        },
    }) {
        super(properties);
        this.tilesBuilt = [TileType_1.TileType.MOON_COLONY];
    }
    discount(player) {
        if (player.playedCards.find((card) => card.name === CardName_1.CardName.MOONCRATE_BLOCK_FACTORY)) {
            return 4 + super.discount(player);
        }
        return super.discount(player);
    }
    canAct(player) {
        const moonData = MoonExpansion_1.MoonExpansion.moonData(player.game);
        const spaces = moonData.moon.getAvailableSpacesForColonyOrRoad(player);
        if (spaces.length === 0)
            return false;
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this, false, 'take this action');
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            const reserveUnits = MoonExpansion_1.MoonExpansion.adjustedReserveCosts(player, this);
            return this.howToAffordReds.canAfford && player.titanium >= reserveUnits.titanium;
        }
        this.howToAffordReds = undefined;
        return super.canAct(player);
    }
    actionEssence(player) {
        const adjustedReserveUnits = MoonExpansion_1.MoonExpansion.adjustedReserveCosts(player, this);
        player.deductUnits(adjustedReserveUnits);
        player.game.defer(new PlaceMoonColonyTile_1.PlaceMoonColonyTile(player));
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1, { log: true });
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainProductionFromMoonTrackIncrease(this.tr) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, standardProject: StandardProjectType_1.StandardProjectType.MOON_COLONY, moonColonyRateIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.MoonColonyStandardProject = MoonColonyStandardProject;
//# sourceMappingURL=MoonColonyStandardProject.js.map